export default __webpack_public_path__ + "static/media/stamp.05078303.jpg";